import script from "./AdminTplView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminTplView.vue?vue&type=script&setup=true&lang=js"

import "./AdminTplView.vue?vue&type=style&index=0&id=1a76b814&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a76b814"]])

export default __exports__